import React from 'react';
import { FileText, Download } from 'lucide-react';
import { Button } from './ui/Button';
interface PDFDownloadCardProps {
  title: string;
  description?: string;
  date?: string;
  size?: string;
  fileName?: string;
}
export function PDFDownloadCard({
  title,
  description,
  date,
  size = 'PDF',
  fileName
}: PDFDownloadCardProps) {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-white border border-slate-200 rounded-lg hover:border-blue-300 hover:shadow-sm transition-all group" data-id="element-179">
      <div className="flex items-start mb-4 sm:mb-0" data-id="element-180">
        <div className="p-3 bg-red-50 text-red-600 rounded-lg mr-4 group-hover:bg-red-100 transition-colors" data-id="element-181">
          <FileText className="w-6 h-6" data-id="element-182" />
        </div>
        <div data-id="element-183">
          <h4 className="font-medium text-slate-900 group-hover:text-blue-900 transition-colors" data-id="element-184">
            {title}
          </h4>
          {description && <p className="text-sm text-slate-500 mt-1" data-id="element-185">{description}</p>}
          <div className="flex items-center mt-2 text-xs text-slate-400 space-x-3" data-id="element-186">
            {date && <span data-id="element-187">{date}</span>}
            {date && <span data-id="element-188">•</span>}
            <span className="uppercase" data-id="element-189">{size}</span>
          </div>
        </div>
      </div>
      <Button variant="outline" size="sm" className="shrink-0 sm:ml-4" data-id="element-190">
        <Download className="w-4 h-4 mr-2" data-id="element-191" />
        Unduh
      </Button>
    </div>;
}